import { html } from 'htm/preact'
import { useState } from 'preact/hooks'
import { api, setToken, token } from '../api.js'
import { REMEMBER_KEY } from '../api.js'

export default function Login() {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const prevRemember = localStorage.getItem(REMEMBER_KEY) === '1'

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const pass = e.target.pass.value
    const remember = e.target.remember.checked
    localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0')
    try {
      const data = await api('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ passphrase: pass }),
      })
      setToken(data.token, remember)
      if (location.hash === '#/' || location.hash === '#' || location.hash === '') {
        window.dispatchEvent(new HashChangeEvent('hashchange'))
      } else {
        location.hash = '#/'
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return html`
    <div class="login-screen">
      <div class="card">
        <h1>Menu Cost</h1>
        <p class="sub">Ingredient catalog & recipe costs (CAD)</p>
        <form onSubmit=${handleSubmit}>
          <div class="field">
            <label for="pass">Passphrase</label>
            <input class="input" id="pass" name="pass" type="password" autocomplete="current-password" autofocus required />
          </div>
          <label class="remember-label">
            <input type="checkbox" name="remember" checked=${prevRemember} />
            Remember this device
          </label>
          <button class="btn btn--primary" type="submit" style="width:100%" disabled=${loading}>
            ${loading ? 'Signing in…' : 'Sign in'}
          </button>
          ${error && html`<p class="login-error">${error}</p>`}
        </form>
      </div>
    </div>
  `
}